<mat-dialog-actions class="justify-content-between">
  <h3>{{ dialogTemplateType !== undefined ? getTemplateTypeLabel(dialogTemplateType) :
    '' }} {{ 'ENTITY.TEMPLATE' | translate }}</h3>
  <button mat-icon-button mat-dialog-close class="d-flex justify-content-center align-items-center"
    (click)="onCloseDialog()">
    <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
  </button>
</mat-dialog-actions>
<mat-divider></mat-divider>
<app-loader></app-loader>
<mat-dialog-content class="mat-typography">
  <!-- <mat-card>
    <mat-card-content> -->
  <div class="row justify-content-between gap-16">
    <div class="col-lg-4">
      <mat-form-field appearance="outline" class="w-100 hide-hint">
        <input matInput [formControl]="searchTemplate"
          placeholder="{{ 'LABEL.SEARCH_LABEL' | translate }} {{ 'ENTITY.TEMPLATE' | translate }}">
        <mat-icon matSuffix>
          <i-tabler name="search" class="icon-20 d-flex m-t-2"></i-tabler>
        </mat-icon>
      </mat-form-field>
    </div>
    <div class="col-lg-4 d-flex align-items-center justify-content-end">
      <button mat-flat-button color="primary" (click)="openAddDialog()">
        <mat-icon>add</mat-icon>
        Add {{ 'ENTITY.TEMPLATE' | translate }}
      </button>
    </div>
  </div>
  <!-- Add Button for non-dialog mode -->
  <div class="row justify-content-end gap-16 m-b-16" *ngIf="!isDialogMode">
    <div class="d-flex align-items-center">
      <button mat-flat-button (click)="openAddDialog()" color="primary" class="list-add-button">
        <mat-icon>add</mat-icon>
        {{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.TEMPLATE' | translate }}
      </button>
    </div>
  </div>
  <div class="table-responsive table-scroll-container" [class.dialog-table-container]="isDialogMode">
    <table mat-table [dataSource]="dataSource" class="w-100">


      <ng-container matColumnDef="templateName">
        <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 align-items-center">
          <div class="d-flex align-items-center gap-15">
            <span>{{ 'LABEL.TEMPLATE_NAME' | translate }}</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element" class="f-s-14 template-name-cell" [class.cursor-pointer]="isDialogMode"
          [class.clickable-template]="isDialogMode" (click)="isDialogMode && onSelectTemplate(element)">
          <div class="d-flex align-items-center">
            <div>
              <p class="f-w-600 mat-subtitle-1 f-s-16 m-0 template-name-text">
                {{ element.templateName ? (element.templateName.length > 20 ?
                (element.templateName.substring(0, 20) + '...') : element.templateName) : '-' }}
              </p>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 sticky">
          {{ 'LABEL.DESCRIPTION' | translate }}
        </th>
        <td mat-cell *matCellDef="let element" class="f-s-14 template-name-text" [class.cursor-pointer]="isDialogMode"
          (click)="isDialogMode && onSelectTemplate(element)">
          {{ element.templateDescription ? (element.templateDescription.length > 50 ?
          (element.templateDescription.substring(0, 50) + '...') : element.templateDescription) : '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 action-header-cell">
          <div class="d-flex align-items-center justify-content-between">
            <span>{{ 'LABEL.ACTION_LABEL' | translate }}</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element" class="action-link">
          <a (click)="editOpenDialog(element)" class="m-r-10 cursor-pointer" matTooltip="Edit Template">
            <i-tabler name="edit" class="icon-20"></i-tabler>
          </a>

          <a (click)="deleteOpenDialog(element.id)" matTooltip="Delete Template">
            <i-tabler name="trash" class="icon-20"></i-tabler>
          </a>

        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.table-row-hover]="isDialogMode"></tr>
    </table>

    <app-empty-state *ngIf="dataSource.data.length === 0" [title]="'LABEL.NO_DATA'">
    </app-empty-state>
  </div>
  <!-- </mat-card-content>
  </mat-card> -->
</mat-dialog-content>
<mat-dialog-actions>
  <mat-paginator class="paginator-fixed" [ngClass]="{'pointer-events-none': isLoading}" [length]="pagination.rowCount"
    [pageSize]="pagination.pageSize" [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true"
    [pageIndex]="pagination.currentPage">

  </mat-paginator>
</mat-dialog-actions>